import * as vp from 'vopay';
import { useHistory } from 'react-router-dom';
import { useEffect, useState } from 'react';
import useFetchAccountBranding from '@/hooks/useApi/useFetchAccountBranding';
import styles from './ElinxPreview.module.scss';
import { useTranslation } from 'react-i18next';

type ElinxPreviewProps = {
  visible: boolean;
  onClose: () => void;
};

const ElinxPreview: React.FC<ElinxPreviewProps> = ({ visible, onClose }) => {
  const { Box, Button, Modal, Preview } = vp;
  const { t } = useTranslation('translations', { keyPrefix: 'Elinx.Preview' });
  const history = useHistory();
  const { fetchAccountBranding } = useFetchAccountBranding();
  const [brandingData, setBrandingData] = useState<vp.AccountBrandingResponse | null>(null);

  useEffect(() => {
    if (visible) {
      fetchAccountBranding({
        Product: vp.BrandingProductType.Elinx,
      })
        .then((response) => setBrandingData(response))
        // Already logged inside the hook; caught here only to avoid an unhandled rejection.
        .catch(() => undefined);
    }
  }, [visible]);

  return (
    <Modal isVisible={visible} enableBgClick={false} zIndex={10}>
      <div className={styles.container}>
        <Box flx="col" ai="center">
          <div className={styles.titleContainer}>
            <h1>{t('title')}</h1>
          </div>
          <div className={styles.descriptionContainer}>
            <p>{t('instructions-one')}</p>
            <p>{t('instructions-two')}</p>
          </div>
          <div>
            <Preview
              preview="elinx"
              logo={brandingData?.Logo || ''}
              primaryColor={brandingData?.BrandingDetails?.PrimaryColor || ''}
              secondaryColor={brandingData?.BrandingDetails?.SecondaryColor || ''}
              width={500}
              height={347}
              slideShow={false}
            />
          </div>
          <div className={styles.buttonBar}>
            <Button
              id="ManageBranding-Settings"
              label={t('manageBrandingButton')}
              color="secondary"
              type="button"
              onClick={() => {
                history.push('/settings/brand-settings');
              }}
            />
            <Button
              id="AddLabel-Accept"
              label={t('confirmButton')}
              color="primary"
              type="button"
              onClick={() => {
                onClose();
              }}
            />
          </div>
        </Box>
      </div>
    </Modal>
  );
};

export default ElinxPreview;
